/**
 * Prepare board/comment HTML (from the admin CKEditor 5 or legacy content) for rendering.
 *
 * - Converts CKEditor's semantic `<oembed url="...">` (emitted when previewsInData is off,
 *   or for providers without a preview) into a responsive YouTube / Vimeo iframe.
 * - Leaves everything else untouched (server side already allow-list sanitizes it).
 */

const YOUTUBE_RE = /^(?:https?:)?\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i;
const VIMEO_RE = /^(?:https?:)?\/\/(?:www\.)?(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/i;

export function embedUrlFor(url) {
  if (!url) return null;
  const u = String(url).trim();
  const yt = u.match(YOUTUBE_RE);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = u.match(VIMEO_RE);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}

const decodeAttr = (value) =>
  String(value)
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');

const escapeAttr = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export function toRenderableHtml(html) {
  if (!html) return '';
  const source = String(html);
  if (!/<oembed\b/i.test(source)) return source;

  return source.replace(/<oembed\b([^>]*)>(?:\s*<\/oembed>)?/gi, (match, attrs) => {
    const m = attrs.match(/\burl\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i);
    const raw = m ? decodeAttr(m[1] || m[2] || m[3] || '') : '';
    const embed = embedUrlFor(raw);
    if (!embed) {
      return raw
        ? `<a href="${escapeAttr(raw)}" target="_blank" rel="noopener noreferrer">${escapeAttr(raw)}</a>`
        : '';
    }
    return (
      `<div class="media-embed" data-oembed-url="${escapeAttr(raw)}">` +
      `<iframe src="${escapeAttr(embed)}" title="video" frameborder="0" ` +
      'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
      'allowfullscreen></iframe></div>'
    );
  });
}
